'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
//var log = require('../log/Log').channel('KayleeCalendar');

var KayleeCalendar = {
    fromJson: fromJson,
    getCalendar: getCalendar,
};

function fromJson(data) {
    var reqProps = [ '$id' ];
    return FirebaseObject.$fromJson(data, 'Calendar', reqProps, reqProps,
        function(data) { return getCalendar(data.$id); }
    );
}

function getCalendar(roomId) {
    var key = 'Calendar: ' + roomId;
    var calendar = KayleeCache.get(key);

    if (calendar === null) {
        calendar = new Calendar(roomId);
        KayleeCache.put(key, calendar);
    }

    return calendar;
}

function Calendar(roomId) {
    this.$nodeType = 'calendar';
    this.$roomId = roomId;
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('calendars/' + roomId));
}

Calendar.prototype = Object.create(FirebaseObject.prototype);
Calendar.prototype.constructor = Calendar;

Calendar.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$id' ]);
};

Calendar.prototype.toString = function() {
    return '[Calendar for room ' + this.$roomId + ']';
};

module.exports = KayleeCalendar;
